/* global process */

/**
 * Auth microservice root used by SDA (IQVIACBEXU-9864).
 * Accepts AUTH_API_BASE_URL (…/unity-dev) or legacy SSO_AUTH_BASE_URL (…/unity-dev/api).
 */
export function getAuthApiBaseUrl(): string {
  const raw = (process.env.AUTH_API_BASE_URL || process.env.SSO_AUTH_BASE_URL || "").trim();
  if (!raw) {
    return "";
  }
  const withoutTrailingSlash = raw.replace(/\/$/, "");
  if (withoutTrailingSlash.endsWith("/api")) {
    return `${withoutTrailingSlash}/auth`;
  }
  return `${withoutTrailingSlash}/api/auth`;
}
